import type { CreateFinanceContactRequest, UpdateFinanceContactRequest } from '../generated/dtos.gen';

const BLANK_ADDRESS_AND_EMPLOYMENT = {
  address: null,
  addressLine2: null,
  city: null,
  state: null,
  zipCode: null,
  email: null,
  phone: null,
  employer: null,
  occupation: null,
  employmentLocation: null,
  employerStreet: null,
  employerCity: null,
  employerState: null,
  employerZip: null,
  canonicalAddressLine1: null,
  canonicalAddressLine2: null,
  canonicalCity: null,
  canonicalState: null,
  canonicalZip: null,
} as const;

export function updateFinanceContactRequest(
  fields: Pick<UpdateFinanceContactRequest, 'concurrencyVersion'> & Partial<UpdateFinanceContactRequest>,
): UpdateFinanceContactRequest {
  return {
    contactKind: null,
    firstName: null,
    middleName: null,
    lastName: null,
    nameSuffix: null,
    organizationName: null,
    committeeFecId: null,
    organizationType: null,
    clearOrganizationType: false,
    multicandidateQualifiedDate: null,
    clearMulticandidateQualification: false,
    sourceCategory: null,
    clearSourceCategory: false,
    recipientOfficeCategory: null,
    clearRecipientOfficeCategory: false,
    ...BLANK_ADDRESS_AND_EMPLOYMENT,
    ...fields,
  };
}

export function createFinanceContactRequest(
  fields: Pick<CreateFinanceContactRequest, 'contactType' | 'contactKind'> & Partial<CreateFinanceContactRequest>,
): CreateFinanceContactRequest {
  return {
    firstName: null,
    middleName: null,
    lastName: null,
    nameSuffix: null,
    organizationName: null,
    committeeFecId: null,
    organizationType: null,
    multicandidateQualifiedDate: null,
    sourceCategory: null,
    recipientOfficeCategory: null,
    ...BLANK_ADDRESS_AND_EMPLOYMENT,
    ...fields,
  };
}
